import { Store } from '../core';

export function loadGoogleAdvertisement(): Promise<boolean> {
  const adConfigPromise = new Promise<boolean>((resolve) => {
    if (!Store.instance.state.adLoaded) {
      (window as any).adBreak({
        preloadAdBreaks: 'on',
        onReady: () => {
          Store.instance.state.adLoaded = true;
          resolve(true);
        },
      });
    } else {
      resolve(true);
    }
  });
  const timeoutPromise = new Promise<boolean>((resolve) => {
    setTimeout(() => {
      resolve(false);
    }, 2000);
  });

  return Promise.race([adConfigPromise, timeoutPromise]);
}

export function showGoogleAdvertisement(): Promise<void> {
  return new Promise((resolve) => {
    (window as any).adBreak({
      type: 'start',
      adBreakDone: () => {
        resolve();
      },
    });
  });
}
